module.exports = __webpack_public_path__ + "img/undraw_exploring_1l7f.3d9b1366.svg";